import React, { useState, useEffect } from 'react';
import '../styles/NotesTable.css';

const AddNotesTable = ({ batchId, openNotesDialogExternally, setOpenNotesDialogExternally }) => {
  const [notes, setNotes] = useState(() => {
    const savedNotes = localStorage.getItem('tempNotes');
    return savedNotes ? JSON.parse(savedNotes) : [];
  });

  const [note, setNote] = useState({
    title: '',
    description: '',
    linkOfAttachment: '',
    status: '',
    batchId: batchId || null,
  });

  const [showDialog, setShowDialog] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  // Errors object to track validation errors
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (openNotesDialogExternally) {
      setShowDialog(true);
      setOpenNotesDialogExternally(false); // Reset parent signal
    }
  }, [openNotesDialogExternally, setOpenNotesDialogExternally]);

  const handleChange = (e) => {
    setNote({ ...note, [e.target.name]: e.target.value });
    // On change, clear the specific field error
    setErrors((prev) => ({ ...prev, [e.target.name]: '' }));
  };

  const validateNote = () => {
    let tempErrors = {};
    if (!note.title?.trim()) tempErrors.title = "Title is required";
    if (!note.description?.trim()) tempErrors.description = "Description is required";
    if (!note.status?.trim()) tempErrors.status = "Status is required";
    return tempErrors;
  };

  const handleAddNote = () => {
    const validationErrors = validateNote();
    if (
      !note.title.trim() &&
      !note.description.trim() &&
      !note.linkOfAttachment.trim() &&
      !note.status.trim()
    ) {
      setShowPopup(true);
      return;
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const updatedNotes = [...notes, note];
    setNotes(updatedNotes);
    localStorage.setItem('tempNotes', JSON.stringify(updatedNotes));

    setNote({
      title: '',
      description: '',
      linkOfAttachment: '',
      batchId: batchId,
    });
    setErrors({});
    setShowDialog(false);
  };

  useEffect(() => {
    setNote((prevNote) => ({
      ...prevNote,
      batchId: batchId || prevNote.batchId,
    }));
  }, [batchId]);

  return (
    <div className="note-container">
      {notes.length > 0 && (<div className="note-header">
        <h3>Notes</h3>
      </div>
      )}


      {/* Add Note Dialog */}
      {showDialog && (
        <div className="dialog-backdrop">
          <div className="dialog-box">
            <h4>Add New Note</h4>

            <div className="form-group">
              <label htmlFor="title">Title</label>
              <input
                type="text"
                id="title"
                name="title"
                placeholder="Enter note title"
                value={note.title}
                onChange={handleChange}
              />
              {errors.title && <div className="error-text">{errors.title}</div>}
            </div>

            <div className="form-group">
              <label htmlFor="description">Description</label>
              <input
                type="text"
                id="description"
                name="description"
                placeholder="Enter note description"
                value={note.description}
                onChange={handleChange}
              />
              {errors.description && <div className="error-text">{errors.description}</div>}
            </div>

            <div className="form-group">
              <label htmlFor="linkOfAttachment">Link of Attachment</label>
              <input
                type="text"
                id="linkOfAttachment"
                name="linkOfAttachment"
                placeholder="Enter attachment link"
                value={note.linkOfAttachment}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="status">Status</label>
              <select
                id='status'
                name='status'
                value={note.status}
                onChange={handleChange}
              >
                <option value="">Select status</option>
                <option value="Enabled">Enabled</option>
                <option value="Disabled">Disabled</option>

              </select>
              {errors.status && <div className="error-text">{errors.status}</div>}
            </div>

            <div className="dialog-actions">
              <button type='button' onClick={handleAddNote}>Save Note</button>
              <button type='button' className="close-btn" onClick={() => setShowDialog(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Popup if all fields blank */}
      {showPopup && (
        <div className="popup-backdrop">
          <div className="popup-box">
            <p>Please fill at least one field before adding a note.</p>
            <button onClick={() => setShowPopup(false)}>OK</button>
          </div>
        </div>
      )}

      {notes.length > 0 && (<table className="note-table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Description</th>
            <th>Attachment</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {notes.map((item, index) => (
            <tr key={index}>
              <td>{item.title}</td>
              <td>{item.description}</td>
              <td>{item.linkOfAttachment}</td>
              <td>{item.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
      )}
    </div>
  );
};

export default AddNotesTable;
